import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
  Button,
  Box,
  Divider,
} from "@mui/material";
import { LotAnalysisDetails } from "./LotAnalysisDetails";

const TruncatedText = ({ children, maxLength = 500 }) => {
  const [expanded, setExpanded] = useState(false);
  const text = typeof children === "string" ? children : "";

  if (!text) return <Typography color="text.secondary">Нет данных</Typography>;

  const isLong = text.length > maxLength;
  const displayText = expanded ? text : text.slice(0, maxLength);

  return (
    <Box>
      <Typography sx={{ whiteSpace: "pre-line", wordBreak: "break-word" }}>
        {displayText}
        {isLong && !expanded && "..."}
      </Typography>

      {isLong && (
        <Button
          size="small"
          sx={{ mt: 1 }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Скрыть" : "Показать ещё"}
        </Button>
      )}
    </Box>
  );
};

export const LotAnalysisModal = ({
  open,
  onClose,
  loading,
  waitingResult,
  error,
  fileData,
  summary,
  retryAnalysis,
  currentLot,
}) => {
  const technicalData = Object.entries(fileData || {})
    .map(([k, v]) => `${k}: ${v}`)
    .join("\n\n");

  const showTechnical = !!fileData;
  const showSummary = !!summary;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Результаты анализа</DialogTitle>
      <Divider />

      <DialogContent>
        {/* ====== ОБЩИЙ ЛОАДЕР ====== */}
        {loading && !showTechnical && !showSummary && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {/* ====== ОБЩАЯ ОШИБКА ====== */}
        {!loading && error && <Typography color="error">{error}</Typography>}

        {/* ====== ТАБЛИЦА ====== */}
        {!loading && !error && (
          <Grid container spacing={3}>
            {/* ---------------- ТЕХНИЧЕСКОЕ ЗАДАНИЕ ---------------- */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6">Техническое задание</Typography>

              <Box sx={{ p: 1, bgcolor: "#fafafa", border: "1px solid #ddd" }}>
                {showTechnical ? (
                  <TruncatedText>{technicalData}</TruncatedText>
                ) : (
                  <Typography color="text.secondary">Нет данных</Typography>
                )}
              </Box>
            </Grid>

            {/* ---------------- РЕЗУЛЬТАТ АНАЛИЗА ---------------- */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6">Результат анализа</Typography>

              <Box sx={{ p: 1, bgcolor: "#fafafa", border: "1px solid #ddd" }}>
                {/* WAITING — показываем только правую колонку */}
                {waitingResult && (
                  <Box textAlign="center">
                    <Typography sx={{ mb: 2 }}>
                      Анализ выполняется, пожалуйста, подождите…
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={() => retryAnalysis(currentLot)}
                    >
                      Обновить
                    </Button>
                  </Box>
                )}

                {/* SUMMARY */}
                {!waitingResult && showSummary && (
                  <LotAnalysisDetails summary={summary} />
                )}

                {/* Если summary нет */}
                {!waitingResult && !showSummary && (
                  <Typography color="text.secondary">
                    Анализ выполняется, пожалуйста, подождите…
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <Box textAlign="right" p={2}>
        <Button onClick={onClose} variant="outlined">
          Закрыть
        </Button>
      </Box>
    </Dialog>
  );
};
